// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"02c9fd49","632":"02c9fd49"}[chunkId] + ".chunk.css";
};